import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "./AuthService";
import {Locupa2Service} from "./Locupa2Service";
import {apiconfig} from "../app/api.config";

@Injectable()
export class PowerBIService{

  apiConfig: any = apiconfig;

  constructor(private httpClient: HttpClient,
              public authService: AuthService,
              private locupa2Service: Locupa2Service) {
  }

  openPowerBIEmbed(locupa2Url: string){
    let h = this.authService.getHttpAuth();

    this.httpClient
      .get(this.apiConfig.API_URL + '/power-bi/access', {headers: h})
      .subscribe((response: any) => {
          if (response) {
             if (response.hasValidToken){
               this.locupa2Service.openLocupa2Window(locupa2Url)
             }
             else {
               let redirectUrl = this.locupa2Service.getLocupa2Url() + locupa2Url;
               let url = this.stringFormat(response.authCodeLoginUrl, {'{url}': redirectUrl});
               let l2Window = window.open(url, 'locupa2');
               l2Window.focus();
               this.locupa2Service.setLocupa2Window(l2Window);
             }
          }
        },
        (error) => {
          // TODO :
        })
    ;
  }

  stringFormat(value: string, replacements: any): string {

    if (value) {
      value = value.replace(/\{[a-zA-Z0-9_\-]+}/g, (param) => {
        return replacements[param] ? replacements[param]: param ;
      });
    }

    return value;
  }
}



// WEBPACK FOOTER //
// ./src/services/PowerBIService.ts